(function() {

    'use strict';



    var XML2 = SAPO.Utility.XML2;



    function AdReqParser(el) { // AdReq
        /*jshint boss:true */

        var resultEls = XML2.getChildren(el, 'Result');
        var resultEl, el2, i, I, tn, item, items = [];

        for (i = 0, I = resultEls.length; i < I; ++i) {
            resultEl = resultEls[i];
            item = {
                lines: []
            };
            el2 = resultEl.firstChild;
            do {
                if (el2.nodeType !== 1) { continue; }
                tn = el2.tagName.toLowerCase();
                if      (tn === 'title') {      item.title      = XML2.trim( XML2.text(el2) ); }
                else if (tn === 'displayurl') { item.displayUrl = XML2.trim( XML2.text(el2) ); }
                else if (tn === 'adlinkurl') {  item.adLinkUrl  = XML2.trim( XML2.text(el2) ); }
                else if (tn.substring(0, 4) === 'line') { item.lines.push( XML2.trim( XML2.text(el2) ) ); }
            } while (el2 = el2.nextSibling);
            items.push(item);
        }

        return items;
    }


    SAPO.Project.Video.VAST.parsers.AdReq = AdReqParser;

})();
